module.exports = __webpack_public_path__ + "b2bab769b4a9d9d8d65a068c95604ae4.MP3";